'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _FullScreenPropertyCellAdditionalInfo = require('./FullScreenPropertyCellAdditionalInfo.scss');var styles = _interopRequireWildcard(_FullScreenPropertyCellAdditionalInfo);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var FullScreenPropertyCellAdditionalInfo = function FullScreenPropertyCellAdditionalInfo(_ref) {var properties = _ref.properties,translate = _ref.translate;
  var propertiesList = Object.keys(properties);

  var property = propertiesList.map(function (item) {return (
      _react2.default.createElement('div', { key: item, className: styles.additionalInfo },
        _react2.default.createElement('span', { className: styles.propertyDetails },
          translate('propertyDetails', 'details', item), '\xA0'),

        _react2.default.createElement('span', null, properties[item] || translate('propertyDetails', 'none'))));});



  return _react2.default.createElement('div', null, property);
};exports.default =

FullScreenPropertyCellAdditionalInfo;

FullScreenPropertyCellAdditionalInfo.propTypes = {
  properties: _propTypes2.default.object,
  translate: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FullScreenPropertyCell/FullScreenPropertyCellAdditionalInfo/FullScreenPropertyCellAdditionalInfo.js
// module id = 2683
// module chunks = 0